import React from 'react';
import SizeGuidePanel from '../components/SizeGuidePanel';

const SizeGuidePage = () => {
  return (
    <div className="min-h-screen bg-neutral-100">
      <div className="max-w-5xl mx-auto px-6 py-12 md:py-16">
        <div className="inline-block bg-black text-white px-4 py-1 mb-4 font-mono text-xs uppercase tracking-widest">
          OWLFIT // FIT_SYSTEM
        </div>
        <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter">Size Guide</h1>
        <p className="text-neutral-600 text-sm font-mono mt-3">
          Find your perfect fit across all Realms. Measurement tolerances are &plusmn;1 inch.
        </p>
        <div className="mt-10">
          <SizeGuidePanel />
        </div>
      </div>
    </div>
  );
};

export default SizeGuidePage;
